import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: "",
    user: ''
  },
  getters: {
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      console.log(token)
      localStorage.setItem('token',token)
      state.token = token
    },
    SET_USER(state, user) {
      localStorage.setItem('user',user)
      state.user = user
    },
  },
  actions: {
  },
  modules: {
  }
})
